import { render } from "./CreateUserModal.vue?vue&type=template&id=53adec3d&scoped=true&ts=true"
import script from "./CreateUserModal.vue?vue&type=script&lang=ts"
export * from "./CreateUserModal.vue?vue&type=script&lang=ts"

import "./CreateUserModal.vue?vue&type=style&index=0&id=53adec3d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53adec3d"]])

export default __exports__